export default __webpack_public_path__ + "static/media/coverpage-04.5dd1aa8b.jpg";